export default {
  accessesUpdate(state, data) {
    state.access = data;
  },

  updateRolesEmployees(state, data) {
    state.rolesEmployees = data;
  },

  updateRoles(state, data) {
    let result = [];
    if (data.dealer_roles) {
      result.push({
        label: 'Ваши роли',
        list: data.dealer_roles,
      })
    }

    if (data.system_roles) {
      result.push({
        label: 'Системные роли',
        list: data.system_roles,
      })
    }
    state.roles = result;
  },

  updateAccessTable(state, data) {
    state.accessTable = data;
  },

  updateAccessCell(state, val) {
    state.accessTable.categories[val.index].permissions[val.permissionsIndex].access_level.splice(val.levelIndex, 1, val.level);
  }
}
